module.exports = __webpack_public_path__ + "img/DKK.6d8845e4.svg";